import { events } from "@planzone/events";
import { createProjectPortfolioError } from "@planzone/dto";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { Boundaries } from "@planzone/core";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: createProjectPortfolioError,
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(state: State): State {
  return { ...state, request: setRequestStateToSuccess() };
}

function handleFailure(
  state: State,
  { error }: Boundaries["createProjectPortfolio"]["failure"],
): State {
  return { ...state, request: setRequestStateToFailure(), error };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createProjectPortfolioRequested]: handleRequest,
    [events.createProjectPortfolioSucceeded]: handleSuccess,
    [events.createProjectPortfolioFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
